const socialLinks = {
  facebook: "https://www.facebook.com/aftershootco",
  pinterest: "https://www.pinterest.com/AfterShootCo",
  twitter: "https://www.twitter.com/aftershootco",
  instagram: "https://www.instagram.com/aftershootco",
  youtube: "https://www.youtube.com/channel/UCvDl1D6YafsMBJOyAXDZU0A",
  tiktok: "https://www.tiktok.com/@aftershootco",
  linkedIn: "https://www.linkedin.com/company/aftershootco",
};

export default socialLinks;
